"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeck = void 0;

var _react = require("react");

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useDeck = function useDeck(ref) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      previousVisible = _useState2[0],
      setPreviousVisibility = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      nextVisible = _useState4[0],
      setNextVisibility = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      scrolling = _useState6[0],
      setScrolling = _useState6[1];

  return {
    previousVisible: previousVisible,
    nextVisible: nextVisible,
    onClickPrevious: function onClickPrevious() {
      if (scrolling) {
        return;
      }

      var _ref$current = ref.current,
          offsetWidth = _ref$current.offsetWidth,
          scrollLeft = _ref$current.scrollLeft;
      setScrolling(true);
      (0, _jquery["default"])(ref.current).animate({
        scrollLeft: "-=".concat(offsetWidth)
      }, 1000, function () {
        setPreviousVisibility(scrollLeft > 0);
        setNextVisibility(true);
        setScrolling(false);
      });
    },
    onClickNext: function onClickNext() {
      if (scrolling) {
        return;
      }

      setScrolling(true);
      var _ref$current2 = ref.current,
          offsetWidth = _ref$current2.offsetWidth,
          scrollWidth = _ref$current2.scrollWidth,
          scrollLeft = _ref$current2.scrollLeft;
      (0, _jquery["default"])(ref.current).animate({
        scrollLeft: "+=".concat(offsetWidth)
      }, 1000, function () {
        setPreviousVisibility(true);
        setNextVisibility(scrollLeft + offsetWidth < scrollWidth);
        setScrolling(false);
      });
    },
    onMouseOver: function onMouseOver() {
      var _ref$current3 = ref.current,
          scrollLeft = _ref$current3.scrollLeft,
          offsetWidth = _ref$current3.offsetWidth,
          scrollWidth = _ref$current3.scrollWidth;
      setPreviousVisibility(scrollLeft > 0);
      setNextVisibility(scrollLeft + offsetWidth < scrollWidth);
    },
    onMouseLeave: function onMouseLeave() {
      setPreviousVisibility(false);
      setNextVisibility(false);
    }
  };
};

exports.useDeck = useDeck;